const Lang = require('lang');

const $idPercurso = $('#idPercurso');
const $kilometragem = $('#kilometragem');

const $titulo = $idPercurso.closest('#modal-percurso, #percurso').find('#titulo');
const $valor = $idPercurso.closest('#modal-percurso, #percurso').find('#valorKm');

if ($idPercurso.length) {
  $.get(route('app.trechos.json'), function(data) {
    $idPercurso.selectize({
      options: data,
      labelField: 'titulo',
      valueField: 'id',
      searchField: 'titulo',
      placeholder: Lang.get('js/src/events/tipo-percurso.select_pre_registered_route'),
      render: {
        item: function(option) {
          return '<div class="item">' + option.titulo + ' - ' + option.kilometragem + 'km' + '</div>';
        },
        option: function(option) {
          return '<div class="option">' + option.titulo + ' - ' + option.kilometragem + 'km' + '</div>'
        }
      }
    });

    const selectize = $idPercurso[0].selectize;

    if($idPercurso.data('selected')) {
      selectize.setValue($idPercurso.data('selected'));
    }

    setCourseStatus(selectize);
    $idPercurso.on('change', () => setCourseStatus(selectize));
  });
}

function setCourseStatus(selectize) {
  if(selectize.getValue().length) {
    $titulo.val(selectize.$control.text());
  }

  if ($idPercurso.val().length) {
    $kilometragem
      .val(selectize.options[$idPercurso.val()].kilometragem)
      .trigger('change')
      .prop('disabled', true);
  } else {
    $kilometragem.prop('disabled', false);
  }
}
